(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media-gallery-content"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const button = target.closest('[data-tp-zoom]');
    if (!(button instanceof HTMLButtonElement)) return;
    const gallery = button.closest('media-gallery');
    const dialog = gallery?.querySelector('zoom-dialog');
    const slideshow = gallery?.querySelector('slideshow-component');
    if (!(dialog instanceof HTMLElement) || typeof dialog.open !== 'function') return;
    const index = slideshow && 'current' in slideshow ? Number(slideshow.current) : 0;
    dialog.open(Number.isFinite(index) ? index : 0, event);
  });
  } catch(e) { console.error(e); }
})();

})();
